import {InPageAlert} from '@snsw-gel/react';
import React from 'react';
import {PhoneElement} from '../../utils/elements';

type ErrorReason = 'existingAccount' | 'genericError' | 'unlinkFailure';

interface ErrorAlertProps {
    readonly errorReason: ErrorReason;
}

/**
 * An in page alert for api failures.
 */
const ErrorAlert: React.FC<ErrorAlertProps> = ({errorReason}) => {
    const [title, description, id] = errorTitleAndDescription(errorReason);

    return <InPageAlert variant='error' title={title} id={id} role='alert'>
        {description}
    </InPageAlert>;
}

function errorTitleAndDescription(errorReason: ErrorReason): [string, React.JSX.Element, string] {
    let title: string;
    let description: React.JSX.Element;
    let id: string;
    switch (errorReason) {
        case 'existingAccount':
            title = 'You already have a Toll Account linked to another MyServiceNSW Account';
            description = <>
                <p>
                    An individual can only link one personal toll account at a time.
                    To view your toll spend, log into the MyServiceNSW account
                    which you have added toll account details to.
                </p>
                <p>
                    If you feel there is an issue or you would like to unlink a toll account
                    from a MyServiceNSW Account please call us on {PhoneElement}.
                </p>
            </>;
            id = 'existingAccount';
            break;

        case 'unlinkFailure':
            title = 'Something went wrong';
            description = <>
                We&apos;re working on this now. Try again later.
                <br/> <br/>
                If the issue keeps happening, call us on {PhoneElement}.
            </>;
            id = 'unlinkFailure';
            break;

        case 'genericError':
            title = 'Account could not be verified';
            description = <>Error occurred.</>;
            id = 'genericError';
            break;
    }

    return [title, description, id];
}

export default ErrorAlert;
export type {ErrorReason};
